import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

const GameRoot = dynamic(() => import('@/components/game/game-root'), {
    ssr: false,
    loading: () => (
        <div className='fixed inset-0 flex flex-col items-center justify-center gap-4 bg-gradient-to-b from-sky-400 via-sky-300 to-emerald-300 p-6 text-center'>
            <p className='text-outline text-5xl font-bold text-white sm:text-7xl'>
                Phonics
                <span className='text-yellow-300'> Grand Prix</span>
            </p>
            <p className='text-lg font-semibold text-white drop-shadow'>
                Starting the engines...
            </p>
        </div>
    )
})

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo description='A 3D phonics racing adventure for Year 1. Explore Phonics Racing Island, blend CVC words, upgrade your race car and win the Phonics Grand Prix.' />

            <h1 className='sr-only'>
                Phonics Grand Prix: CVC Race
            </h1>

            <GameRoot />
        </Layout>
    )
}

export default Home
